enum DeniedPermissionViews {
    case_list = "case_list",
    browser_list = "browser_list",
    safari = "safari",
    chrome_desktop = "chrome_desktop",
    chrome_ios = "chrome_ios",
    chrome_android = "chrome_android",
    device_in_use = "device_in_use",
}
export { DeniedPermissionViews };